import { useFrame } from '@react-three/fiber';
import { useLayerStore } from '../LayerControls/layerStore';
import { useState } from 'react';
import { Mesh, MeshStandardMaterial } from 'three';

interface UseHighlighterProps {
  layerKey: string;
}

export const useHighlighter = ({ layerKey }: UseHighlighterProps) => {
  const { highlightedLayer } = useLayerStore();

  useFrame((state) => {
    const isHighlighted = highlightedLayer === layerKey;

    const group = state.scene.getObjectByName(layerKey);
    if (group) {
      group.traverse((child) => {
        if (child instanceof Mesh) {
          const material = child.material as MeshStandardMaterial;

          if (isHighlighted) {
            if (!material.userData.originalOpacity) {
              material.userData.originalOpacity = material.opacity;
              material.userData.originalColor = material.color.clone();
            }
            material.opacity = 1;
            material.color.set('rgb(0, 255, 0)');
          } else {
            if (material.userData.originalOpacity) {
              material.opacity = material.userData.originalOpacity;
              material.color.set(material.userData.originalColor);
            }
          }
        }
      });
    }
  });
};

const defaultLabelStyles = {
  backgroundColor: 'rgba(206, 206, 206, 0.7)',
  color: 'black',
  border: '1px solid rgba(140, 140, 140, 0.3)',
};

const highlightedLabelStyles = {
  backgroundColor: 'rgba(0, 255, 0, 0.7)',
  color: 'black',
  border: '1px solid rgba(0, 255, 0, 0.7)',
};

export const useLabelHighlighter = ({ layerKey }: UseHighlighterProps) => {
  const { highlightedLayer } = useLayerStore();

  const [styles, setStyles] = useState(defaultLabelStyles);

  useFrame(() => {
    const isHighlighted = highlightedLayer === layerKey;
    if (isHighlighted) {
      setStyles(highlightedLabelStyles);
    } else {
      setStyles(defaultLabelStyles);
    }
  });

  return { styles };
};
